var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trending-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sliders-container occasion" },
      [
        _c(
          "VueSlickCarousel",
          {
            attrs: {
              infinite: true,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1
            },
            scopedSlots: _vm._u([
              {
                key: "prevArrow",
                fn: function(arrowOption) {
                  return [
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648"
                        }
                      })
                    ])
                  ]
                }
              },
              {
                key: "nextArrow",
                fn: function(arrowOption) {
                  return [
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648"
                        }
                      })
                    ])
                  ]
                }
              }
            ])
          },
          [
            _vm._v(" "),
            _c("div", { staticClass: "trending-slide" }, [
              _c("div", { staticClass: "content-container feb" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v("The Q4 Corporate Gifting Trend Report")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "subtitle" }, [
                  _vm._v(
                    "Holiday gifting is almost here! Download the report for the latest gifting insights to impress clients & reward your team."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "happybox-button green border",
                    attrs: {
                      href: "https://happyboxstore.com/index#q4trendReport2024"
                    }
                  },
                  [_vm._v("Download the Report")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "image-container" }, [
                _c("img", {
                  staticClass: "lazyload",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/q4trendreport.png?v=1727725250"
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title mobile" }, [
                _vm._v("The Q4 Corporate Gifting Trend Report")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "trending-slide" }, [
              _c("div", { staticClass: "content-container feb" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v("Welcome "),
                  _c("br"),
                  _vm._v(" Them Back "),
                  _c("br"),
                  _vm._v(" to the Office")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "subtitle" }, [
                  _vm._v(
                    "Maybe it’s their first time back to the office in quite a while. Extend a warm welcome by leaving a thoughtful care package on their desk, setting the tone for a smooth transition back."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "happybox-button green border",
                    attrs: { href: "/pages/ready-to-ship" }
                  },
                  [_vm._v("Browse the Collection")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "image-container" }, [
                _c("img", {
                  staticClass: "lazyload",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/deskdrop.png?v=1711382937"
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title mobile" }, [
                _vm._v("Welcome "),
                _c("br"),
                _vm._v(" Them Back "),
                _c("br"),
                _vm._v(" to the Office")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "trending-slide" }, [
              _c("div", { staticClass: "content-container" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v("Our Event "),
                  _c("br"),
                  _vm._v(" Gifting Service")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "subtitle" }, [
                  _vm._v(
                    "Whether it's for a corporate conference or an intimate\r\n                    celebration, we'll help you create a thoughtfully curated\r\n                    gift that will be "
                  ),
                  _c("br", { staticClass: "desktop" }),
                  _vm._v(" cherished by your guests.")
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "happybox-button green border",
                    attrs: {
                      target: "_blank",
                      href: "https://meetings.hubspot.com/corporate-gifting"
                    }
                  },
                  [_vm._v("Book a Call")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    loading: "lazy",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/event.png?v=1709316145"
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title mobile" }, [
                _vm._v("Our Event "),
                _c("br"),
                _vm._v(" Gifting Service")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "trending-slide" }, [
              _c("div", { staticClass: "content-container" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v("Care Packages for the Whole Team")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "subtitle" }, [
                  _vm._v(
                    "Show your team some love and build a custom gift right now! Shipping made easy."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "happybox-button green border",
                    attrs: { id: "builder", href: "/products/build-a-box" }
                  },
                  [_vm._v("Start building")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    loading: "lazy",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/raiseaglass2.jpg?v=1704228993"
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title mobile" }, [
                _vm._v("Care Packages for "),
                _c("br"),
                _vm._v(" the Whole Team")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "trending-slide" }, [
              _c("div", { staticClass: "content-container" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v("Revitalize Your Workplace")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "subtitle" }, [
                  _vm._v(
                    "Stress is so last season. Embrace corporate wellness for a healthier, happier, and more productive team in 2024."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "happybox-button white border",
                    attrs: { href: "/collections/wellness" }
                  },
                  [_vm._v("Shop wellness gifts")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "image-container" }, [
                _c("img", {
                  staticClass: "lazyload",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/products/3bc81609fd6822f4f44bf98014bc2ffd224d78f65c7a9d28efad777d8aa1a31c.webp?v=1674963892"
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title mobile" }, [
                _vm._v("Revitalize Your Workplace")
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "trending-title-container" }, [
      _c("span", [_vm._v("TRENDING")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }